export const brandName = 'DreamJob'
export const brandNameFull ='DreamJob Discovery'